import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { graphql, useApolloClient } from 'react-apollo';

import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import ErrorView from '../../../../components/global/ErrorView';
import SelfieRequestLinkHandlerMeta from './components/SelfieRequestLinkHandlerMeta';
import { HierarchyItemForMatches } from '../HierarchyItem/Matches/graphql/queries/hierarchy-item';
import { getSimplifiedAlbumMembershipGroupQuery } from '../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getSimplifiedAlbumMembershipGroup';

const propTypes = {
  hierarchyItem: PropTypes.shape({
    id: PropTypes.string,
  }),
  loadingHierarchyItem: PropTypes.bool,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
};

const SelfieRequestLinkHandler = ({
  hierarchyItem,
  loadingHierarchyItem,
  history,
}) => {
  const client = useApolloClient();

  const onSelfieRequestRedirect = async () => {
    const rootAlbumFolderId =
      hierarchyItem?.album?.root_album_folder?.id ??
      hierarchyItem?.album_folder?.root?.id;

    const {
      data: { albumMembershipGroup },
    } = await client.query({
      query: getSimplifiedAlbumMembershipGroupQuery,
      variables: {
        id: rootAlbumFolderId,
      },
    });

    // Onboard if there is no membership group for the account.
    if (!albumMembershipGroup) {
      history.replace(`/discover/album-folder/${hierarchyItem?.id}/`);
    } else {
      history.replace(`/consumer/identities`);
    }
  };

  useEffect(() => {
    if (hierarchyItem) {
      onSelfieRequestRedirect();
    }
  }, [hierarchyItem]);

  if (loadingHierarchyItem) {
    return <FullScreenLoader />;
  }

  if (!loadingHierarchyItem && !hierarchyItem) {
    return (
      <ErrorView
        location={{
          state: {
            error:
              'It looks like the link provided does not match any of our records.',
          },
        }}
      />
    );
  }

  return (
    <Fragment>
      <SelfieRequestLinkHandlerMeta hierarchyItem={hierarchyItem} />
      <FullScreenLoader />
    </Fragment>
  );
};

SelfieRequestLinkHandler.propTypes = propTypes;

export { SelfieRequestLinkHandler as SelfieRequestLinkHandlerComp };

const withHierarchyItemForMatches = graphql(HierarchyItemForMatches, {
  options: ({ match }) => ({
    variables: {
      id: match.params.hierarchyItemId,
    },
  }),
  props: ({ data: { hierarchyItem, loading } }) => ({
    hierarchyItem,
    loadingHierarchyItem: loading,
  }),
});

export default compose(
  withRouter,
  withHierarchyItemForMatches,
)(SelfieRequestLinkHandler);
